import React from 'react';
import reactStringReplace from 'react-string-replace';

type MultiHighlightTextProps = {text: string; term: string};

const multiHighlightText = ({text, term}: MultiHighlightTextProps): React.ReactNode => {
  const termsStr = term
    .split(/\s+/g)
    .map((h) => h.trim())
    .filter((h) => h != '')
    .join('|');
  const highlightsRegex = new RegExp(`(${termsStr})`, 'gi');
  return (
    <>
      {reactStringReplace(text, highlightsRegex, (m, index) => (
        <span className='highlight' key={index}>
          {m}
        </span>
      ))}
    </>
  );
};

export default multiHighlightText;
